export enum LocalStorageKey {
  ShouldSkipEmailLinking = 'should-skip-email-linking',
  DefaultLoginMethod = 'default-login-method',
  ConcreteDirectData = 'concrete-direct-data',
  ScanStationReportFilter = 'scan-station-filter',
  FormReportReportFilter = 'form-report-filter',
  DeliveryReportReportFilter = 'delivery-report-filter',
  AttachmentsFilter = 'attachments-filter',
  EquipmentFilter = 'equipment-filter',
  // -v2 retires configs saved before Equipment got default column order,
  // freezing and visibility, so everyone lands on the new defaults once.
  EquipmentColumnConfig = 'equipment-column-config-v2',
  // -v2 retires configs saved before the Controls tab froze Name by default,
  // so everyone lands on the new defaults once.
  EquipmentControlsColumnConfig = 'equipment-controls-column-config-v2',
  // -v2 retires configs saved before StruxTags got default column order,
  // freezing and visibility, so everyone lands on the new defaults once.
  StruxTagsColumnConfig = 'struxtags-column-config-v2',
  LocationsColumnConfig = 'locations-column-config-v2',
  LocationsControlsColumnConfig = 'locations-controls-column-config-v2',
  LocationsFormsColumnConfig = 'locations-forms-column-config',
  LocationsPropertiesColumnConfig = 'locations-properties-column-config',
  // -v2 retires configs saved before Materials got default column order,
  // freezing and visibility, so everyone lands on the new defaults once.
  MaterialsColumnConfig = 'materials-column-config-v2',
  // -v2 retires configs saved before the Controls tab froze Name by default,
  // so everyone lands on the new defaults once.
  MaterialsControlsColumnConfig = 'materials-controls-column-config-v2',
  UserDirectoryColumnConfig = 'user-directory-column-config',
  CompanyDirectoryColumnConfig = 'company-directory-column-config',
  FormTypesColumnConfig = 'form-types-column-config',
  EquipmentFormsColumnConfig = 'equipment-forms-column-config',
  EquipmentPropertiesColumnConfig = 'equipment-properties-column-config',
  MaterialsFormsColumnConfig = 'materials-forms-column-config',
  MaterialsPropertiesColumnConfig = 'materials-properties-column-config',
  WorkflowSavedView = 'workflow-saved-view',
  NotificationSavedView = 'notification-saved-view',
  UploadLogSavedView = 'upload-log-saved-view',
  LastUsedScanner = 'last-used-scanner',
  ActiveScanner = 'active-scanner',
  ScannedUsers = 'scanned-users',
  GetTheAppBannerDismissed = 'get-the-app-banner-dismissed',
  OneTimePopup = 'one-time-popup',
  Tenant = 'tenant',
  AlwaysShowSettingsSidebar = 'always-show-settings-sidebar',
  WorkflowMarkupsVisible = 'workflow-markups-visible',
  WorkflowMarkupLabelsVisible = 'workflow-markup-labels-visible',
  ShowAdjacentMarkups = 'show-adjacent-markups',
  DeletedParentLocationsBannerDismissed = 'deleted-parent-locations-banner-dismissed',
}
